import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "./SuccessStories.css";
import { SLIDER_AUTOPLAY_DELAY_MS } from "../constants/sliderTiming";
import useScrollAnimation from "../constants/useScrollAnimation";

export default function SuccessStories() {
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);
  const successData = [
    {
      img: "/images/sussess-stories/ojosshi-roy.png",
      name: "Ojosshi Roy",
      institute: "TIGPS Siliguri",
      score: "97.40%",
      exam: "TIGPS Siliguri",
    },
    {
      img: "/images/sussess-stories/swapnajeet-biswas.png",
      name: "Swapnajeet Biswas",
      institute: "TIGPS Siliguri",
      score: "97%",
      exam: "TIGPS Siliguri",
    },
    {
      img: "/images/sussess-stories/kaushar-mitra.png",
      name: "Kaushar Mitra",
      institute: "TIGPS Siliguri",
      score: "96%",
      exam: "TIGPS SIliguri",
    },
    {
      img: "/images/sussess-stories/anuska-yadav.png",
      name: "Anuska Yadav",
      institute: "TIGPS Bolpur",
      score: "96.60%",
      exam: "TIGPS Bolpur",
    },
    {
      img: "/images/sussess-stories/shreyam-bhattacharya.png",
      name: "Sounava Sarkar",
      institute: "TIGPS Bolpur",
      score: "96%",
      exam: "TIGPS Bolpur",
    },
    {
      img: "/images/sussess-stories/olivia-saha.png",
      name: "Olivia Saha",
      institute: "TIGPS Jalpaiguri",
      score: "95.60%",
      exam: "TIGPS Jalpaiguri",
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [navPrevEl, setNavPrevEl] = useState(null);
  const [navNextEl, setNavNextEl] = useState(null);

  useEffect(() => {
    setNavPrevEl(prevRef.current);
    setNavNextEl(nextRef.current);
  }, []);

  return (
    <section id="success-stories-hm-section" className="success-stories-hm-section">
      <div className="section-bg">
        <div className="container-custom">

          {/* Section Header */}


          <div ref={headerRef} className={`section-header ${isHeaderVisible ? "animate-in" : ""}`}>
            <div className="section-title-body">
              <div>
                <h3 className="section-title-hm">Success Stories</h3>
              </div>
              <div className="success-nav d-flex align-items-center">
                <button
                  ref={prevRef}
                  className="success-nav-btn success-prev"
                  aria-label="Previous"
                >
                  <img
                    src="/images/sussess-stories/icon/arrow-left.png"
                    alt="Previous"
                    className="success-nav-icon"
                  />
                </button>
                <button
                  ref={nextRef}
                  className="success-nav-btn success-next"
                  aria-label="Next"
                >
                  <img
                    src="/images/sussess-stories/icon/arrow-right.png"
                    alt="Next"
                    className="success-nav-icon"
                  />
                </button>
              </div>
            </div>
          </div>

          {/* Cards Carousel */}
          <div ref={contentRef} id="success-stories-hm-container" className={`success-stories-hm-container schools-right ${isContentVisible ? "animate-in" : ""}`}>
            <Swiper
              id="success-stories-hm-swiper"
              className="success-stories-hm-swiper"
              modules={[Navigation, Autoplay]}
              navigation={{ prevEl: navPrevEl, nextEl: navNextEl }}
              spaceBetween={18}
              slidesPerView={5}
              loop={true}
              speed={1400}
              grabCursor={true}
              autoplay={{
                delay: SLIDER_AUTOPLAY_DELAY_MS || 3000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                1600: { slidesPerView: 5 },
                1400: { slidesPerView: 4 },
                1200: { slidesPerView: 4 },
                992: { slidesPerView: 3 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1 },
                360: { slidesPerView: 1 },
              }}
            >
              {successData.map((item, index) => (
                <SwiperSlide key={index} id={`success-stories-hm-slide-${index}`} className="success-stories-hm-slide">
                  <div id={`success-stories-hm-card-${index}`} className="success-stories-hm-card">
                    {/* Background Image */}
                    <div
                      id={`success-stories-hm-card-bg-${index}`}
                      className="success-stories-hm-card-bg"
                      style={{ backgroundImage: `url(${item.img})` }}
                    />

                    {/* Gradient Overlay */}
                    <div id={`success-stories-hm-card-overlay-${index}`} className="success-stories-hm-card-overlay" />

                    {/* Card Content Box */}
                    <div id={`success-stories-hm-card-content-${index}`} className="success-stories-hm-card-content">
                      <h3 id={`success-stories-hm-card-title-${index}`} className="success-stories-hm-card-title">{item.name}</h3>

                      {/* Line-by-Line Hover Details */}
                      <div id={`success-stories-hm-card-hover-info-${index}`} className="success-stories-hm-card-hover-info">
                        <p id={`success-stories-hm-card-school-${index}`} className="success-stories-hm-card-school">{item.institute}</p>
                        <p id={`success-stories-hm-card-score-${index}`} className="success-stories-hm-card-score">Score: {item.score}</p>
                        <p id={`success-stories-hm-card-board-${index}`} className="success-stories-hm-card-board">{item.exam}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

        </div>
      </div>
    </section>
  );
}